var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('b-navbar',{staticClass:"footer-navbar"},[_c('img',{attrs:{"src":require("../assets/scialari.svg"),"height":"30"}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }